export default "__VITE_ASSET__b55f920e__"